export default __webpack_public_path__ + "static/media/chefartur.8e8fd86b.jpg";